/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. Original work by Solvetia — part of the Solvetia
 * white-label additions to Chatwoot Community Edition (MIT). Not derived from
 * the commercial code under enterprise/.
 */
/**
 * Maps the Account Role form (name, description, and a map of permission flags)
 * to the payload the backend expects, turning the checked flags into a
 * permissions array.
 */
export function buildAccountRolePayload(form) {
  return {
    name: form.name,
    description: form.description,
    permissions: Object.keys(form.permissionFlags || {}).filter(
      key => form.permissionFlags[key]
    ),
  };
}
